import React from 'react';
import SwapWalletItem from '../SwapWalletItem';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import SwapWalletsEmpty from '../SwapWalletsEmpty';
import cn from 'classnames';
import './style.scss';
import { identity } from "../../../utils/getIdentity";

const SwapWalletsList = ({
  exchangeWallets,
  exchangeWalletsFetching,
  activeWalletId,
  handleSelect,
  setSelectedWalletBalance,
  currenciesArray,
  exchangeFields,
  currencyFieldIsEdited,
  currencyNumber,
  selectedCurrencyId,
}) => {
  const getWalletAssets = wallet =>
    wallet?.tokens?.length > 0
      ? wallet.tokens
      : (wallet?.balances || []).map(asset => ({
          balance: asset?.balance,
          currency: asset?.currency?.name,
          currencyId: asset?.currency?.id,
          nodeType: asset?.currency?.nodeType,
          currencyType: asset?.currency?.currencyType,
        }));

  return (
    <div
      className={cn('swap-wallets-list', {
        'swap-wallets-list_selected': activeWalletId,
      })}
      key={activeWalletId}
    >
      {!exchangeWalletsFetching || (currencyFieldIsEdited !== 'none' && currencyFieldIsEdited !== currencyNumber && exchangeWalletsFetching) ? (
        exchangeWallets && exchangeWallets.entities.length ? (
          exchangeWallets.entities.map(wallet =>
            getWalletAssets(wallet).length ? (
              getWalletAssets(wallet)
                .filter(token => !selectedCurrencyId || token?.currencyId === selectedCurrencyId)
                .map((token, index) => (
                <SwapWalletItem
                  key={`${wallet._id}-${token?.currencyId || token?.currency || index}`}
                  wallet={token}
                  id={wallet._id}
                  address={wallet.address}
                  isMain={wallet.main}
                  activeWalletId={activeWalletId}
                  handleSelect={handleSelect}
                  balance={token?.balance?.value}
                  setSelectedWalletBalance={setSelectedWalletBalance}
                  currenciesArray={currenciesArray}
                />
              ))
            ) : (
              (!selectedCurrencyId || wallet?.currencyId === selectedCurrencyId) && (
                <SwapWalletItem
                  key={wallet._id}
                  wallet={wallet}
                  id={wallet._id}
                  address={wallet.address}
                  isMain={wallet.main}
                  activeWalletId={activeWalletId}
                  handleSelect={handleSelect}
                  balance={wallet.balance.value}
                  setSelectedWalletBalance={setSelectedWalletBalance}
                  currenciesArray={currenciesArray}
                  exchangeFields={exchangeFields}
                />
              )
            )
          )
        ) : (
          <SwapWalletsEmpty />
        )
      ) : (
        <>{(currencyFieldIsEdited === currencyNumber || currencyFieldIsEdited==='none') ? <Spin className="swap-wallets-list__loader" indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} /> : null}</>
      )}
    </div>
  );
};

// const SwapWalletsList = ({
//   exchangeWallets,
//   exchangeWalletsFetching,
//   activeWalletId,
//   handleSelect,
//   setSelectedWalletBalance,
// }) => {
//   useEffect(() => {
//     document.querySelector('.main-layout__content-wrap').scrollTo(0, 0);
//   }, []);
//   return (
//     <div
//       className={cn('swap-wallets-list', {
//         'swap-wallets-list_selected': activeWalletId,
//       })}
//     >
//       {!exchangeWalletsFetching ? (
//         exchangeWallets && exchangeWallets.entities.length ? (
//           exchangeWallets.entities.map(wallet =>
//             wallet.tokens.length ? (
//               wallet.tokens.map(token => (
//                 <SwapWalletItem
//                   wallet={token}
//                   id={wallet._id}
//                   address={wallet.address}
//                   isMain={wallet.main}
//                   activeWalletId={activeWalletId}
//                   handleSelect={handleSelect}
//                   balance={token.balance.value}
//                   setSelectedWalletBalance={setSelectedWalletBalance}
//                 />
//               ))
//             ) : (
//               <SwapWalletItem
//                 wallet={wallet}
//                 id={wallet._id}
//                 address={wallet.address}
//                 isMain={wallet.main}
//                 activeWalletId={activeWalletId}
//                 handleSelect={handleSelect}
//                 balance={wallet.balance.value}
//                 setSelectedWalletBalance={setSelectedWalletBalance}
//               />
//             )
//           )
//         ) : (
//           <SwapWalletsEmpty />
//         )
//       ) : (
//         <Spin className="swap-wallets-list__loader" indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
//       )}
//     </div>
//   );
// };

export default SwapWalletsList;


